import { getMintPageUrl } from "~config";

const useReferral = () => {
  const searchParams = new URLSearchParams(document.location.search);

  const referrerParam = (referrer?: string | null) =>
    referrer ? `?referrer=${referrer}` : "";

  const mintUrlWithReferrer = (
    collection: { id: string; onchainId: string },
    referrer?: string | null
  ) => {
    const mintUrl = getMintPageUrl(collection, { withBaseUrl: true });
    return `${mintUrl}${referrerParam(referrer)}`;
  };

  const referrerQueryParamValue = searchParams.get("referrer") || undefined;

  return {
    referrerQueryParamValue,
    mintUrlWithReferrer,
  };
};

export default useReferral;
